export default ({ loggedUser, loggedUserCompany }) => ({
  loggedUser,
  loggedUserCompany,
});
